// THE HOME WIDGET FORM HOST — a widget's "+" opens ONLY its create form, as a
// modal sheet over the board, never the whole app page (Nika's pick 10 C,
// 2026-09-28: "when widget invokes modal (for example +) it … can just open +
// modal"; the picks page: "'+' on Recent contacts opens the create form only.
// No full app page; the new contact appears in the widget at once").
//
// THE CONTRACT (a module's manifest, the widget's one square button):
//
//   action: { icon: 'plus', label: '<key>', call: '<fn>', form: '<Component>' }
//
// `form` names a component the MODULE registers — an AppDialog sheet whose
// `stateKey` opens it (the CRM's CrmContactCreateModal / CrmDealCreateModal).
// The frame's button (functions/homeWidgetFrame.js homeWidgetRunAction) asks
// this host to mount that form first, then runs the module's `call` with
// `{ form: true }` so the module only SEEDS its draft (the dialog opens on
// it) instead of routing to its page. The host mounts the form with the
// module's OWN context — its components, functions, design system and state
// scope (root._moduleDsCtxGet, the context a module widget body mounts with)
// — so the form reads and writes exactly the draft its module seeded.
//
// AN AI ANSWER'S FORM CARD (functions/assistantAppForms.js) asks the same
// way, and hands the app's `open` with the request: the host runs it ON the
// mounted form, so the seed lands in the scope the form reads.
//
// ITS OWN STATE. `state: {}` gives the host a state of its own, which
// mountHomeWidgetForm points at the scope of each form BEFORE mounting it
// (moduleStateScope.js scopeHostState): the module's state root, or the shell
// root for a shell form. A form's `if:` runs before the module scope's plugin
// does, so without this its first read — and an open made while it is parked
// — reached the SHELL root, and the app's own close then shadowed every later
// seed (WS-ASSISTANT-APP-FORM-OPEN-SHELL-SCOPE-1). The host itself reads only
// `_homeWidgetForm`, a shell-owned key every module store shares.
//
// GEOMETRY. AppDialog fills its frame (`absolute`, inset 0) and floats its
// panel inside it; this host IS that frame: fixed over the whole viewport, at
// the house modal layer (DESIGN_SPEC §6.8 — Modal.js 2000: over the header,
// the composer and a PageSlot window), and click-through: AppDialog takes the
// pointer itself while it is open (its `&[data-open]` rule) and none at rest.
// A closed dialog stays mounted and inert until another form replaces it —
// nothing to tear down.
export const HomeWidgetFormHost = {
  position: 'fixed',
  inset: '0',
  zIndex: '2000',
  pointerEvents: 'none',
  state: {},
  subscribeTo: ['_homeWidgetForm'],
  // A FIRST-NEED LATCH owned by the component (the shell's boot budget,
  // __tests__/shellStageLadder.test.js): no subtree at boot — the host builds
  // the first time a widget asks for a form, and stays for the next one.
  if: (el, s) => !!(s.root._homeWidgetForm && s.root._homeWidgetForm.form),
  // `onMounted`, not onCreate: a late `if:` activation (the first "+") runs
  // Init, AttachNode and Mounted — never Create — so the first form mounts
  // here; every later request (a fresh `seq`) arrives through onUpdate. Both
  // are idempotent per request (mountHomeWidgetForm's signature).
  onMounted: (el, s) => el.call('mountHomeWidgetForm', el, s.root._homeWidgetForm),
  onUpdate: (el, s) => el.call('mountHomeWidgetForm', el, s.root._homeWidgetForm)
}
